import React, { useState } from "react";
import DeleteModal from "../../commonComponent/DeleteModal";
import EventViewModal from "./EventViewModal";
import { useLocation, useNavigate } from "react-router-dom";
import DateInput from "../../commonComponent/CutomDatePicker";
import { ImCross, ImFileText2 } from "react-icons/im";
import { AiFillEye } from "react-icons/ai";
import { getEventsbyGroupId, removeGroupFromEventById, removeIdByType } from "../../services/GroupService";
import { useEffect } from "react";
import { format } from "date-fns";
import { changeDateFormatYYYY, showToastError, showToastSuccess } from "../../Utils/Helper";
import Navbar from "../header/Navbar";
import Sidebar from "../sidebar/Sidebar";
import Loader from "../../commonComponent/Loader";
import { FiEye, FiTrash } from "react-icons/fi";

function EventList() {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state;
  const [modalShow, setModalShow] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [groupId, setGroupId] = useState(state.selectedgroup._id);
  console.log(state.selectedgroup);
  useEffect(() => {
    getEventsbyId(groupId);
  }, [groupId]);

  const getEventsbyId = async (Id) => {
    let parmsId = Id;
    try {
      const response = await getEventsbyGroupId(parmsId);
      if (response.status === 200) {
        console.log(response?.data?.data);
        setEventList(response?.data?.data);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const removeEventnById = async(id) =>{
    let params = {}
    params['groupId'] = state.selectedgroup._id;
    // params['type'] = 'event';
    params['eventId'] = id;
    console.log(params)
    try {
      const response = await removeGroupFromEventById(params);
      if(response?.data?.status === 200){
        showToastSuccess('Event Removed')
        getEventsbyId(groupId);
        console.log(response)
      }else{
        showToastError('Error Occured')
      }
    } catch (error) {
      showToastError(error || 'Error Occured from catch')
    }

  }

  return (
    <>
      <Navbar />
      <div className="container-fluid mb-5">
        <div className="row">
          <div className="col-md-2">
            <Sidebar />
          </div>
          <div className="col-md-10 py-4 px-5">
            <div className="row">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li
                    class="breadcrumb-item pointer"
                    onClick={() => navigate(-2)}
                  >
                    Groups
                  </li>
                  <li
                    class="breadcrumb-item pointer"
                    onClick={() => navigate(-1)}
                  >
                    Details
                  </li>
                  <li
                    class="breadcrumb-item active fw-bold"
                    aria-current="page"
                  >
                    Events
                  </li>
                </ol>
              </nav>
            </div>{" "}
            <div className="row align-items-center mt-4">
              <div className="col-md-8">
                <h4 className="mb-3">Upcoming Events</h4>
              </div>
              <div className="col-md-4">
                <div className="row">
                  <div className="col-md-4">
                    <button
                      className="description_btntoday w-100"
                      style={{
                        backgroundColor: "#1f7e78",
                        borderColor: "#1f7e78",
                      }}
                    >
                      Today
                    </button>
                  </div>
                  <div className="col-md-8">
                    <DateInput
                      // value={startDateCreate}
                      // onChangeDate={(date) => {
                      //     setStartDateCreate(date)
                      //     setError({ ...error, start_date: false })

                      // }}
                      // maxDate={endDateCreate}
                      minDate={new Date()}
                      inputClassName={
                        "description_inputf d-flex align-items-center"
                      }
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              {eventList?.length > 0 ?
              
              <table className="table table-hover">
                <thead>
                  <tr className="text-start">
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Title
                    </td>
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Date
                    </td>
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Time
                    </td>
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Location
                    </td>
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Service
                    </td>
                    <td className="py-4 fw-semibold " scope=" text-secondary">
                      Action
                    </td>
                  </tr>
                </thead>
                <tbody className="p-0">
                {isLoading ? (
                <center>
                  <Loader
                    visible={isLoading}
                    style={{ top: "-15px", position: "relative" }}
                  />{" "}
                </center>
              ) : null}
                  {eventList?.length > 0 &&
                    eventList.map((event) => {
                      return (
                        <tr
                          // key={dt._id}
                          className="text-start"
                          key={event._id}
                        >
                          <td>
                            {event?.title}
                            {/* {dt.full_name && dt.full_name} */}
                          </td>
                          <td
                            style={{
                              width: "",
                            }}
                          >
                            {format(new Date(event?.eventDate), "d MMMM YYY")}
                            {/* {dt.age && dt.age} */}
                          </td>
                          <td style={{}}>
                            {format(new Date(event?.startTime), "HH:MM")}
                            {/* {dt.gender && dt.gender} */}
                          </td>
                          <td>
                            {event?.location}
                            {/* {`${changeDateFormat[1]}-${changeDateFormat[2]}-${changeDateFormat[0]}`} */}
                          </td>
                          <td className="text_unset">
                            {event?.serviceType}
                            {/* {dt.time} */}
                          </td>
                          <td>
                            <button
                              // onClick={() => onStartSession(dt?.sessionLink_doctor)}
                              className="btn btn-light me-2"
                            >
                              <span>
                                <ImFileText2 className="mb-1 " />
                              </span>
                            </button>
                            <button
                              onClick={() => {
                                navigate("/viewevent", { state: { selectedEvent: event} })
                              }}
                              // onClick={() => onStartSession(dt?.sessionLink_doctor)}
                              className="btn btn-light"
                            >
                              <span>
                                <FiEye className="mb-1 " />
                              </span>
                            </button>
                            <button
                              className="btn btn-light ms-2"
                                // onClick={() => updateBooking({ "bookingId": dt._id, "status": "cancelled" })}
                              onClick={()=>removeEventnById(event._id)}
                            >
                              <span >
                                <FiTrash />
                              </span>
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                    

                  {/* }
                    )} */}
                </tbody>
              </table> :  <center>
                          <p className="fs-5">No Events Here...</p>
                    </center>}

              {/* ) : (<div className="card p-2"><div className="card-body">There are currently no appointments.</div></div>)} */}
            </div>
            
            <DeleteModal
              title={"Delete"}
              content1={"Are you sure, you want to cancel"}
              content2={"this event?"}
              modalId={"deleteEvent"}
              button2={"No"}
              button1={"Yes"}
                // onDelete={() => deleteMember(memberId)}
            />
            <EventViewModal
              // gname={state?.selectedGroup?.groupName}
              // gid={state?.selectedGroup?._id}
              show={modalShow}
              // getGroupPosts={getGroupPosts}
              onHide={() => setModalShow(false)}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default EventList;
